<script>
import capitalize from 'lodash/capitalize'
import camelCase from 'lodash/camelCase'
import ProviderInformationTab from './tabs/provider-information-tab'
import ProviderProductsTab from './tabs/provider-products-tab'
import ProviderProducts from '@/components/products-table'
import deleteProvider from './delete-provider-modal'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Provider',
  components: {
    ProviderInformationTab,
    ProviderProductsTab,
    ProviderProducts,
    deleteProvider,
  },
  data() {
    return {
      activeTab: '',
      loading: true,
      provider: {},
      modals: {
        delete: false,
      },
    }
  },
  computed: {
    ...mapGetters('me', [
      'canUpdateProvider',
      'canDeleteProvider',
      'canCreateApiKey',
      'canReadApiKey',
    ]),
    providerId() {
      return this.$route.params.id || null
    },
    back() {
      return {
        name: 'providers',
      }
    },
    commands() {
      return [
        this.canUpdateProvider && {
          command: 'edit',
          label: 'Edit Provider Details',
        },
        this.canCreateApiKey && {
          command: 'create-api-key',
          label: 'Create API Key',
        },
        this.canDeleteProvider && {
          command: 'delete',
          label: 'Delete Provider',
        },
      ]
    },
    showMenu() {
      return !!this.commands.find(i => i)
    },
    tabs() {
      return [
        {
          label: 'Provider Information',
          name: 'information',
        },
        {
          label: 'Provider Products',
          name: 'products',
        },
      ]
    },
  },
  async created() {
    this.getApiKeys()
    const [, response] = await this.getProvider({ id: this.providerId })
    this.activeTab = this.$route.params.tab || this.tabs[0].name
    this.provider = response
    this.loading = false
  },
  methods: {
    ...mapActions('provider', [
      'getProvider',
    ]),
    ...mapActions('apiKeys', [
      'getApiKeys',
    ]),
    capitalize,
    camelCase,
    onClick() {
      this.$router.push({
        name: 'provider-edit',
        params: {
          id: this.$route.params.id,
        },
      })
    },
    onTabClick(newTab, prevTab) {
      if (newTab !== prevTab) {
        this.$router.push({
          name: 'provider-details',
          params: {
            id: this.providerId,
            tab: newTab,
          },
        })
      }
    },
    handleCommand(command) {
      switch (command) {
        case 'edit':
          this.onClick()
          break
        case 'create-api-key':
          this.$router.push({
            name: 'api-key-create',
            params: {
              providerId: this.providerId,
            },
          })
          break
        case 'delete':
          this.modals.delete = true
          break
      }
    },
  },
}
</script>

<template>
  <main-layout
    :title="provider.name"
    :back="back"
    :loading="loading"
  >
    <div
      v-if="showMenu"
      slot="header"
      :class="$style.caption"
    >
      <el-dropdown
        trigger="click"
        @command="handleCommand"
      >
        <dropdown-icon />
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(command, index) in commands"
            :key="index"
            :command="command.command"
          >
            {{ command.label }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <el-tabs
      v-model="activeTab"
      :before-leave="onTabClick"
    >
      <el-tab-pane
        v-for="tab in tabs"
        :key="tab.name"
        :label="tab.label"
        :name="tab.name"
        :loading="loading"
        lazy
      >
        <component
          :is="`Provider${capitalize(camelCase(tab.name))}Tab`"
          v-if="activeTab === tab.name"
          :ref="`${tab.name}Tab`"
          :provider="provider"
        />
      </el-tab-pane>
    </el-tabs>


    <delete-provider
      v-if="modals.delete"
      :visible.sync="modals.delete"
      :provider="provider"
    />
  </main-layout>
</template>

<style lang="scss" module>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title {
  display: flex;
  flex: 1 0 50%;
  align-items: center;
}

.divider {
  margin: rem(40px 0);
}
</style>
